/**
 * Utility functions for map-related operations
 */

/**
 * Generates a Google Maps directions URL from an address
 * @param address The destination address for directions
 * @returns A Google Maps URL that opens directions to the address
 */
export function getGoogleMapsDirectionsUrl(address: string): string {
  // Format address for URL and encode it
  const formattedAddress = encodeURIComponent(address);
  return `https://www.google.com/maps/dir/?api=1&destination=${formattedAddress}`;
}

/**
 * Opens Google Maps directions to the specified address in a new tab
 * @param address The destination address for directions
 */
export function openGoogleMapsDirections(address: string): void {
  const url = getGoogleMapsDirectionsUrl(address);
  window.open(url, '_blank', 'noopener,noreferrer');
}

/**
 * Default address string for Tannenboden Chalet
 */
export const TANNENBODEN_ADDRESS = "Sattelboden 1, 6390 Engelberg, Switzerland";